import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
interface PageBannerProps {
  title: string;
  subtitle?: string;
}
export function PageBanner({
  title,
  subtitle
}: PageBannerProps) {
  return <section className="relative pt-40 pb-24 overflow-hidden bg-[#060C1A]" aria-label={title} data-id="element-174">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true" data-id="element-175">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#1E1F55_1px,transparent_1px),linear-gradient(to_bottom,#1E1F55_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-20" data-id="element-176" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#4AA6CF] rounded-full mix-blend-screen filter blur-[150px] opacity-10" data-id="element-177" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-179">
          {/* Breadcrumb */}
          <nav aria-label="Breadcrumb" className="flex items-center justify-center gap-2 text-sm text-white/80 mb-6 font-medium" data-id="element-180">
            <Link to="/" className="hover:text-white transition-colors" data-id="element-181">
              Home
            </Link>
            <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-182" />
            <span className="text-[#4AA6CF]" aria-current="page" data-id="element-183">
              {title}
            </span>
          </nav>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 tracking-tight" data-id="element-184">
            {title}
          </h1>

          {subtitle && <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-185">
              {subtitle}
            </p>}
        </motion.div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent" aria-hidden="true" data-id="element-186" />
    </section>;
}